var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");require("./clojure.string.js");
'use strict';$CLJS.rF=new $CLJS.N(null,"form","form",-1624062471);$CLJS.cj.g(0);